import { useAuthStore } from 'stores/authStore';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

const useSelectedRetailerProfile = () => {
  const profiles = useAuthStore((state) => state.user?.profiles);
  const selectedBrandUid = useSelectedProfileStore((state) => state.selectedBrandUid);
  const selectedRegionUid = useSelectedProfileStore((state) => state.selectedRegionUid);

  if (!profiles?.length || !selectedBrandUid || !selectedRegionUid) {
    return null;
  }

  return (
    profiles.find(
      (profile) =>
        profile.brand.uid === selectedBrandUid && profile.region.uid === selectedRegionUid,
    ) || null
  );
};

export default useSelectedRetailerProfile;
